import { Component, Input, OnInit } from '@angular/core';
import * as Classes from '../../../classes/models.classes';

@Component({
    selector: 'app-media-carousel',
    templateUrl: './media-carousel.component.html',
    styleUrls: ['./media-carousel.component.css']
})
export class MediaCarouselComponent implements OnInit {

    @Input() UserID: number;
    @Input() mediaItems: Classes.PostMedia[] = [];
    @Input() responsiveOptions: any[] = [];

    ngOnInit(): void {
        this.mediaItems = (this.mediaItems || []).map((item, index) => ({
            ...item,
            index,
        }));
    }

    get displayCount(): number {
        const n = this.mediaItems?.length || 0;
        if (n <= 0) { return 0; }
        if (n === 1) { return 1; }
        if (n === 2) { return 2; }
        if (n === 3) { return 3; }
        return 4;
    }

    get gridSlice(): Classes.PostMedia[] {
        return (this.mediaItems || []).slice(0, 4);
    }

    get extraMediaCount(): number {
        return Math.max(0, (this.mediaItems?.length || 0) - 4);
    }

    isLocalVideo(item: Classes.PostMedia): boolean {
        return item?.mediaSource === 'local' && !!item.mimeType?.startsWith('video/');
    }

    getMediaUrl(item: Classes.PostMedia): string {
        let url = '';
        if (item.mediaSource === 'local') {
            url = `api/content/media?fileName=${item.fileName}&mimeType=${item.mimeType}&userID=${this.UserID}`;
        } else if (item.mediaSource === 'url') {
            url = item.mediaUrl;
        }
        return url;
    }

    onCarouselClick(event: MouseEvent): void {
        event.stopPropagation();
    }

    togglePlay(index: number, event: MouseEvent): void {
        event.stopPropagation();
        if (index >= 0 && index < this.mediaItems.length) {
            if (this.mediaItems[index].isTenor) {
                this.mediaItems[index] = {
                    ...this.mediaItems[index],
                    isPlaying: !this.mediaItems[index].isPlaying,
                };
            }
        }
    }

}
